import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL || 'https://yetutv-backend.onrender.com';

// Configure axios
const token = localStorage.getItem('token');
if (token) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

// Videos
export const getVideos = (params = {}) => {
  return axios.get(`${API_URL}/api/videos`, { params });
};

export const getVideo = (videoId) => {
  return axios.get(`${API_URL}/api/videos/${videoId}`);
};

export const uploadVideo = (formData) => {
  return axios.post(`${API_URL}/api/videos/upload`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

export const approveVideo = (videoId) => {
  return axios.put(`${API_URL}/api/videos/${videoId}/approve`);
};

export const updateVideoStatus = (videoId, status) => {
  return axios.put(`${API_URL}/api/videos/${videoId}/status?new_status=${status}`);
};

// Likes
export const likeVideo = (videoId) => {
  return axios.post(`${API_URL}/api/videos/${videoId}/like`);
};

export const unlikeVideo = (videoId) => {
  return axios.delete(`${API_URL}/api/videos/${videoId}/like`);
};

export const checkIfLiked = (videoId) => {
  return axios.get(`${API_URL}/api/videos/${videoId}/liked`);
};

// Watch
export const logWatch = (data) => {
  const formData = new FormData();
  Object.keys(data).forEach(key => formData.append(key, data[key]));
  return axios.post(`${API_URL}/api/watch/log`, formData);
};

export const incrementView = (videoId) => {
  const formData = new FormData();
  formData.append('video_id', videoId);
  return axios.post(`${API_URL}/api/watch/view`, formData);
};

// Ratings
export const rateVideo = (videoId, stars) => {
  const formData = new FormData();
  formData.append('video_id', videoId);
  formData.append('stars', stars);
  return axios.post(`${API_URL}/api/ratings`, formData);
};

export const getUserRating = (videoId) => {
  return axios.get(`${API_URL}/api/ratings/${videoId}/user`);
};

// Comments
export const getComments = (videoId) => {
  return axios.get(`${API_URL}/api/comments/${videoId}`);
};

export const createComment = (videoId, text) => {
  const formData = new FormData();
  formData.append('video_id', videoId);
  formData.append('text', text);
  return axios.post(`${API_URL}/api/comments`, formData);
};

// Watchlist
export const getWatchlist = () => {
  return axios.get(`${API_URL}/api/watchlist`);
};

export const addToWatchlist = (videoId) => {
  const formData = new FormData();
  formData.append('video_id', videoId);
  return axios.post(`${API_URL}/api/watchlist`, formData);
};

export const removeFromWatchlist = (videoId) => {
  return axios.delete(`${API_URL}/api/watchlist/${videoId}`);
};

// Creator
export const getCreatorVideos = () => {
  return axios.get(`${API_URL}/api/creator/videos`);
};

export const getCreatorAnalytics = () => {
  return axios.get(`${API_URL}/api/creator/analytics`);
};

// Admin
export const getPendingVideos = () => {
  return axios.get(`${API_URL}/api/admin/pending-videos`);
};

export const getAdminStats = () => {
  return axios.get(`${API_URL}/api/admin/stats`);
};

// Payout
export const getMyPayouts = () => {
  return axios.get(`${API_URL}/api/payouts/my-requests`);
};

export const requestPayout = (data) => {
  const formData = new FormData();
  Object.keys(data).forEach(key => formData.append(key, data[key]));
  return axios.post(`${API_URL}/api/payouts/request`, formData);
};

export const getAllPayouts = (status) => {
  const params = status ? { status } : {};
  return axios.get(`${API_URL}/api/admin/payouts`, { params });
};

export const updatePayoutStatus = (payoutId, status, notes) => {
  const formData = new FormData();
  formData.append('new_status', status);
  if (notes) formData.append('notes', notes);
  return axios.put(`${API_URL}/api/admin/payouts/${payoutId}`, formData);
};

// Trending & Recommendations
export const calculateTrendingScores = () => {
  return axios.post(`${API_URL}/api/videos/calculate-trending`);
};

export const getRecommendedVideos = (limit = 10) => {
  return axios.get(`${API_URL}/api/videos/recommended`, { params: { limit } });
};

// Referrals
export const getReferralStats = () => {
  return axios.get(`${API_URL}/api/referrals/my-stats`);
};

export const checkReferralCode = (code) => {
  return axios.get(`${API_URL}/api/referrals/check/${code}`);
};

// Stream URL
export const getStreamUrl = (path) => {
  return `${API_URL}/api/stream/${path}`;
};


// Creator Requests
export const submitCreatorRequest = (data) => {
  const formData = new FormData();
  Object.keys(data).forEach(key => formData.append(key, data[key]));
  return axios.post(`${API_URL}/api/creator-requests`, formData);
};

export const getMyCreatorRequest = () => {
  return axios.get(`${API_URL}/api/creator-requests/me`);
};

export const getAllCreatorRequests = (status) => {
  const params = status ? { status } : {};
  return axios.get(`${API_URL}/api/admin/creator-requests`, { params });
};

export const updateCreatorRequest = (requestId, status, notes) => {
  const formData = new FormData();
  formData.append('new_status', status);
  if (notes) formData.append('admin_notes', notes);
  return axios.put(`${API_URL}/api/admin/creator-requests/${requestId}`, formData);
};

// Notifications
export const getNotifications = (unreadOnly = false, limit = 20, skip = 0) => {
  return axios.get(`${API_URL}/api/notifications`, {
    params: { unread_only: unreadOnly, limit, skip }
  });
};

export const markNotificationRead = (notificationId) => {
  return axios.post(`${API_URL}/api/notifications/${notificationId}/read`);
};

export const markAllNotificationsRead = () => {
  return axios.post(`${API_URL}/api/notifications/read-all`);
};

// Admin - Gestion utilisateurs
export const getAllUsers = (params = {}) => {
  return axios.get(`${API_URL}/api/admin/users`, { params });
};

export const updateUserRole = (userId, newRole) => {
  const formData = new FormData();
  formData.append('new_role', newRole);
  return axios.put(`${API_URL}/api/admin/users/${userId}/role`, formData);
};

export const deleteUser = (userId) => {
  return axios.delete(`${API_URL}/api/admin/users/${userId}`);
};

export const resetUserPassword = (userId, newPassword) => {
  const formData = new FormData();
  formData.append('new_password', newPassword);
  return axios.post(`${API_URL}/api/admin/users/${userId}/reset-password`, formData);
};

export const adjustUserPoints = (userId, delta, reason) => {
  const formData = new FormData();
  formData.append('delta', delta);
  formData.append('reason', reason);
  return axios.put(`${API_URL}/api/admin/users/${userId}/points`, formData);
};

// Admin - Vidéos
export const getAllVideosAdmin = (params = {}) => {
  return axios.get(`${API_URL}/api/admin/all-videos`, { params });
};

export const adminDeleteVideo = (videoId) => {
  return axios.delete(`${API_URL}/api/admin/videos/${videoId}`);
};

// Admin - Codes promo
export const getPromoCodes = () => {
  return axios.get(`${API_URL}/api/admin/promo-codes`);
};

export const createPromoCode = (data) => {
  return axios.post(`${API_URL}/api/admin/promo-codes`, data);
};

export const togglePromoCode = (id) => {
  return axios.put(`${API_URL}/api/admin/promo-codes/${id}/toggle`);
};

export const deletePromoCode = (id) => {
  return axios.delete(`${API_URL}/api/admin/promo-codes/${id}`);
};

export const applyPromoCode = (code) => {
  const formData = new FormData();
  formData.append('code', code);
  return axios.post(`${API_URL}/api/promo-codes/apply`, formData);
};

// Admin - Analytics visionnage
export const getAnalyticsViewers = (params = {}) => {
  return axios.get(`${API_URL}/api/admin/analytics/viewers`, { params });
};

export const getAnalyticsCreators = (params = {}) => {
  return axios.get(`${API_URL}/api/admin/analytics/creators`, { params });
};

export const getAnalyticsUserWatches = (userId) => {
  return axios.get(`${API_URL}/api/admin/analytics/user/${userId}/watches`);
};

export const getAnalyticsCreatorViewers = (creatorId) => {
  return axios.get(`${API_URL}/api/admin/analytics/creator/${creatorId}/viewers`);
};

// Admin - Paramètres plateforme
export const getAdminSettings = () => {
  return axios.get(`${API_URL}/api/admin/settings`);
};

export const updateAdminSettings = (settings) => {
  return axios.put(`${API_URL}/api/admin/settings`, { settings });
};

// Admin - Logs
export const getAdminLogs = (params = {}) => {
  return axios.get(`${API_URL}/api/admin/logs`, { params });
};

// Admin - Broadcast
export const broadcastNotification = (data) => {
  const formData = new FormData();
  formData.append('title', data.title);
  formData.append('body', data.body);
  formData.append('target', data.target);
  return axios.post(`${API_URL}/api/admin/broadcast`, formData);
};

// Admin - Stats enrichies
export const getAdminStatsFull = () => {
  return axios.get(`${API_URL}/api/admin/stats/full`);
};

// People (Cast/Acteurs)
export const getPeople = (search, limit = 20, skip = 0) => {
  const params = { limit, skip };
  if (search) params.search = search;
  return axios.get(`${API_URL}/api/people`, { params });
};

export const getPerson = (personId) => {
  return axios.get(`${API_URL}/api/people/${personId}`);
};

export const createPerson = (data) => {
  const formData = new FormData();
  Object.keys(data).forEach(key => {
    if (data[key]) formData.append(key, data[key]);
  });
  return axios.post(`${API_URL}/api/people`, formData);
};

// Video Cast
export const getVideoCast = (videoId) => {
  return axios.get(`${API_URL}/api/videos/${videoId}/cast`);
};

export const addVideoCast = (videoId, data) => {
  const formData = new FormData();
  Object.keys(data).forEach(key => formData.append(key, data[key]));
  return axios.post(`${API_URL}/api/videos/${videoId}/cast`, formData);
};

export const removeVideoCast = (castId) => {
  return axios.delete(`${API_URL}/api/videos/cast/${castId}`);
};

